import React, { Component } from 'react'
import { connect } from 'react-redux';
let RealContentView = null;

class ContentView extends Component {
  	constructor(props) {
    	super(props);
    	this.state = { isReady: RealContentView !== null };
  	}

  	componentDidMount() {
  		const {isEditor} = this.props
  		
  		if(!isEditor) return
  		this.load()
  	}
  	
	componentWillReceiveProps({isEditor}) {
		if(isEditor && !RealContentView) this.load()
	}

  	load() {
    	require.ensure('../admin', () => {
      		RealContentView = require('../admin').RealContentView;
      		if (!this.hasUnmounted) {
        		this.setState({ isReady: true });
      		}
    	});
  	}

  	componentWillUnmount() {
    	this.hasUnmounted = true;
  	}

  	render() {
  		return this.state.isReady ? <RealContentView/> : null;
  	}
}

export default connect(state => ({isEditor: state.auth.isEditor}))(ContentView);



// WEBPACK FOOTER //
// ./src/fm/admin/content/ContentView.js